import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import MetisMenu from "metismenujs";
import { Router, NavigationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";

import { SIDEBAR_COLOR } from "../layouts.model";
import { OrganisationSettingService } from "src/app/_services/organisation-setting/organisation-setting.service";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { FunctionCategoryEnum,IApiresponse } from "src/app/_models";
import { CommonModule } from "@angular/common";
import { SimplebarAngularModule } from "simplebar-angular";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { ProgressBarComponent } from '../../shared/design-system/progress-bar/progress-bar.component';
import { OrgBasicFunctionSubscriptionService } from "src/app/_services/billing-pricing/Org-BasicFunction-Subscription.service";
import { DatePipe } from "@angular/common";
import { environment } from "src/environments/environment";
import { ICONS } from "../../_helpers/icons.constants";
import { ProgressBarConfig } from "../../shared/design-system/progress-bar/progress-bar.modal";
import { ButtonComponent } from '../../shared/design-system/button/button.component';
import { ButtonConfig } from "../../shared/design-system/button/button.modal";
import {SelfSetupService} from "../../_services/self-setup/self-setup.service";
import {SelfSetupStausEnum} from "../../_models/enum/solo-enum";
import {SelfSetupRequest} from "../../_models/self-setup/self-setup";
import { BookDemoPanelComponent } from "src/app/purchase-order/book-demo-panel/book-demo-panel.component";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    standalone: true,
    imports: [CommonModule, SimplebarAngularModule, NgbTooltipModule, TranslateModule, RouterLink, ProgressBarComponent, ButtonComponent,BookDemoPanelComponent]
})

/**
 * Sidebar Component
 */
export class SidebarComponent implements OnInit {
  @ViewChild("sideMenu") sideMenu!: ElementRef;
  public ICONS = ICONS;
  menu: any;
  menuItems: MenuItem[] = [];

  isSidebar: any;
  claims: Claims;
  selectedMenuId: number = 0;
  bandId: number = 0;
  isFinanceManager: boolean = false;
  basicFunctionTrialDays: number = 0;
  basicFunctionRemainingTrialDays: number = 0;
  basicFuncEndDate: any = "";
  isBasicFunctionPurchased: boolean = false;
  isDisplayEssDetail: boolean = false;
  freeTrialProgressBar : ProgressBarConfig = {
      type: 'progress-orange',
      progressValue: this.basicFunctionRemainingTrialDays*100/this.basicFunctionTrialDays
  };

  subscribeButtonConfig: ButtonConfig = {
      id:"btnSubscribe",
      label: this.translate.instant('Subscribe'),
      color: "success",
      size: "sm",
      block: true
  };
  isSelfSetupOn: boolean = false;
  selfSetupPercentage: number = 0;
  selfSetupProgressBar : ProgressBarConfig = {
      type: 'self-setup-progress',
      progressValue: 0
  };
  showBookDemoPanel: boolean = false;
  
  constructor(
    private router: Router,
    public translate: TranslateService,
    private organisationSettingService: OrganisationSettingService,
    private claimsService: ClaimsService,
    private orgBasicFunctionSubscriptionService: OrgBasicFunctionSubscriptionService,
    private datepipe: DatePipe,
    private selfSetupService: SelfSetupService
  ) {

    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;  
      this.bandId = this.claims.BandId;
      this.isFinanceManager = this.claims.IsFinanceManager;
      this.isBasicFunctionPurchased = this.claims.isBasicFunctionPurchased;
      this.isSelfSetupOn = this.claims.IsSelfSetupOn;
      this.selfSetupPercentage = this.claims.SelfSetupPercentage;
      this.selfSetupProgressBar.progressValue = this.selfSetupPercentage;
    });
    if(localStorage.getItem("currentselectedMenuId")!=null)
    {
      this.selectedMenuId = parseInt(localStorage.getItem("currentselectedMenuId"), 10);
    }
    this.selectedMenuId =
      this.routeIsActive("/claimant") ||
      this.routeIsActive("/approver") ||
      this.routeIsActive("/financeapprover") ||
      this.routeIsActive("/pay") ||
      this.routeIsActive("/export") ||
      this.routeIsActive("/universalimport/ccuploadfile") ||
      this.routeIsActive("/card") ||
      this.routeIsActive("/ManageSubscription") ||
      this.routeIsActive("/referandearn") ||
      this.routeIsActive("/support") ||
      this.routeIsActive("/changepassword") ||
      this.routeIsActive("/calander")
        ? -1
        : this.selectedMenuId;

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
         this.applySelectionFromUrlOrStorage();
        //this._activateMenuDropdown();
        this.selectedMenuId =
          this.routeIsActive("/claimant") ||
          this.routeIsActive("/approver") ||
          this.routeIsActive("/financeapprover") ||
          this.routeIsActive("/pay") ||
          this.routeIsActive("/export") ||
          this.routeIsActive("/universalimport/ccuploadfile") ||
          this.routeIsActive("/card") ||
          this.routeIsActive("/ManageSubscription") ||
          this.routeIsActive("/referandearn") ||
          this.routeIsActive("/support") ||
          this.routeIsActive("/changepassword") ||
          this.routeIsActive("/calander")
            ? -1
            : this.selectedMenuId;

        if (localStorage.getItem("backFromPolicy") == "1") {
          this.selectedMenuId = 6;
          setTimeout(() => {
            this.selectedMenuId = this.claimsService.selectedPackageCategory =
              this.selectedMenuId;
            this.claimsService.updateSelectedPackageCategory(
              this.selectedMenuId
            );
            localStorage.removeItem("backFromPolicy");
          }, 100);
        } else if (localStorage.getItem("fromExploreAppEssentialPack") == "1") {
          this.selectedMenuId = 1;
          setTimeout(() => {
            this.selectedMenuId = this.claimsService.selectedPackageCategory =
              this.selectedMenuId;
            this.claimsService.updateSelectedPackageCategory(
              this.selectedMenuId
            );
            localStorage.removeItem("fromExploreAppEssentialPack");
          }, 100);
        } else if(localStorage.getItem("ExpenseCategories") == "1"){
          this.selectedMenuId = FunctionCategoryEnum.ExpenseCategories;
          setTimeout(() => {
            this.selectedMenuId = this.claimsService.selectedPackageCategory =
              this.selectedMenuId;
            this.claimsService.updateSelectedPackageCategory(
              this.selectedMenuId
            );
            localStorage.removeItem("ExpenseCategories");
          }, 100);
        }
        else if (localStorage.getItem("forSpecialCategory") == "1") {
          this.selectedMenuId = FunctionCategoryEnum.ExpenseCategories;
          setTimeout(() => {
            this.selectedMenuId = this.claimsService.selectedPackageCategory =
              this.selectedMenuId;
            this.claimsService.updateSelectedPackageCategory(
              this.selectedMenuId
            );
            localStorage.removeItem("forSpecialCategory");
          }, 100);
        }
        else if (localStorage.getItem("forApAutomation") == "1") {
          this.selectedMenuId = FunctionCategoryEnum.APAutomation;
          setTimeout(() => {
            this.selectedMenuId = this.claimsService.selectedPackageCategory =
              this.selectedMenuId;
            this.claimsService.updateSelectedPackageCategory(
              this.selectedMenuId
            );
            localStorage.removeItem("forApAutomation");
          }, 100);
        }
      }
    });
  }

  routeIsActive(routePath: string) {
    let currentUrl = this.router.url;
    return currentUrl.startsWith(routePath);
  }

  isSidebarCollapsed(): boolean {
    const sidebarSize = document.body.getAttribute("data-sidebar-size");
    return sidebarSize === "sm";
  }

  ngOnInit(): void {
    this.menuItems = []; //MENU;
    this.getMySubscriptionSettings();
    this.isSidebar = SIDEBAR_COLOR;
    this.applySelectionFromUrlOrStorage();
    if (this.isSidebar === "dark") {
      document.body.setAttribute("data-sidebar", "dark");
    }
    this.fnGetOrgBasicFunctionSubscriptionTrialDetails();
    this.fnGetOrgSelfSetupDetail();
  }


  applySelectionFromUrlOrStorage() {
      const fullUrl = this.router.url || window.location.pathname || "";
      const currentPath = fullUrl.split("?")[0];
      if (currentPath === "/" || currentPath === "" || currentPath === "/dashboard/overview") {
        this.selectedMenuId = 0;
        try { localStorage.setItem("currentselectedMenuId", "2"); } catch (e) {}
        try { this.claimsService.selectedPackageCategory = 2; this.claimsService.updateSelectedPackageCategory(2); } catch (e) {}
      } else if (currentPath === "/settings") {
        const raw = new URLSearchParams(fullUrl.split("?")[1] || "").get("selectedMenuId");
        if (raw != null && !isNaN(parseInt(raw, 10))) {
          const id = parseInt(raw, 10);
          this.selectedMenuId = id;
          try { localStorage.setItem("currentselectedMenuId", id.toString()); } catch (e) {}
          try { this.claimsService.selectedPackageCategory = id; this.claimsService.updateSelectedPackageCategory(id); } catch (e) {}
          // Strip the selectedMenuId query param from the URL now that it's applied
          this.router.navigate([], { queryParams: {}, replaceUrl: true });
        } else if (localStorage.getItem("currentselectedMenuId") != null) {
          this.selectedMenuId = parseInt(localStorage.getItem("currentselectedMenuId"), 10);
        }
      } else if (localStorage.getItem("currentselectedMenuId") != null) {
        this.selectedMenuId = parseInt(localStorage.getItem("currentselectedMenuId"), 10);
      }
    }

  navigateToSettings(item: MenuItem) {
    localStorage.setItem("currentselectedMenuId", item.id.toString());
    this.selectedMenuId = item.id;
    if (item.id == 0) {
      this.router.navigate([""]);
    } else {
      this.selectedMenuId = this.claimsService.selectedPackageCategory =
        item.id;
      this.claimsService.updateSelectedPackageCategory(item.id);
      //this._activateMenuDropdown();
      this.router.navigate(["/settings"]);
    }
  }

  getMySubscriptionSettings() {
    let functionDetails = [];
    this.organisationSettingService
      .GetOrganisationSettingList()
      .subscribe((data) => {
        if (data.statusCode == 0) {
          let item = {
            id: 0,
            label: "Dashboard",
            link: "",
            isTitle: false,
            icon: "../../svg-icons/functioncategory/inactive/dashboard",
            iconInactive: "../../svg-icons/functioncategory/active/dashboard",
          };

          item["subItems"] = [];
          this.menuItems.push(item);

          data.responseInfo.functionCategoryDetail.forEach((x) => {
            if (
              x.functionCategoryId == FunctionCategoryEnum.Travel &&
              !this.claims?.IsTravelCategoryAllowed
            ) {
              return;
            }

            if (x.functionCategoryId != 16 && x.functionCategoryId != 17) {
              let item = {
                id: x.functionCategoryId,
                label: x.functionCategoryName,
                isTitle: false,
                link: "/settings",
                icon:
                  "../../svg-icons/functioncategory/inactive/functioncategory_" +
                  x.functionCategoryId,
                iconInactive:
                  "../../svg-icons/functioncategory/active/functioncategory_" +
                  x.functionCategoryId,
                isEssentialPackage:
                  x.functionPackageDetail.filter((x) => x.isEssential).length >
                  0,
              };

              item["subItems"] = [];
              this.menuItems.push(item);

            }
          });
        }
      });
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    this.menu = new MetisMenu("#side-menu");
    //this._activateMenuDropdown();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass("mm-active");
    this._removeAllClass("mm-show");
    const links: any = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add("mm-active");
        const parent2El = parentEl.parentElement.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");
            if (childAnchor) {
              childAnchor.classList.add("mm-active");
            }
            if (childDropdown) {
              childDropdown.classList.add("mm-active");
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  fnGetOrgBasicFunctionSubscriptionTrialDetails() {
    this.orgBasicFunctionSubscriptionService
      .GetOrgBasicFunctionSubscriptionTrialDetails(this.claims.OrgId)
      .subscribe((res: any) => {
        if (res.responseInfo != null) {
          let todayDate = new Date();

          this.basicFunctionRemainingTrialDays =
            res.responseInfo.basicFunctionRemainingTrialDays;
          todayDate.setDate(
            todayDate.getDate() + this.basicFunctionRemainingTrialDays
          );
          let formatDate = this.datepipe.transform(
            todayDate,
            environment.dateFormat
          );
          this.basicFuncEndDate = formatDate;
          this.basicFunctionTrialDays = res.responseInfo.basicFunctionTrialDays;
          this.isBasicFunctionPurchased =
            res.responseInfo.isBasicFunctionPurchased;
          this.claims.isBasicFunctionPurchased =
            res.responseInfo.isBasicFunctionPurchased;
          this.claimsService.updateClaims(this.claims);
          this.freeTrialProgressBar = {...this.freeTrialProgressBar, 
            progressValue: this.basicFunctionRemainingTrialDays*100/this.basicFunctionTrialDays};
        }
      });
  }

    fnEssBtnClick(clickType: number) {
    this.isDisplayEssDetail = false;
    switch (clickType) {
      case 1:
        this.fnInvoicesClick();
        break;
      case 2:
      case 3:
        this.changeBillingPlan();
        break;
      default:
        break;
    }
  }

    fnInvoicesClick() {
    this.claims.profileActiveTab = "billing";
    this.claims.invoiceActiveTab = "your-invoices";
    this.claimsService.updateClaims(this.claims);
    this.router.navigate(["profilemenu"]);
  }

    changeBillingPlan() {
    this.claims.profileActiveTab = "billing";
    this.claims.invoiceActiveTab = "billing-cost-control";
    this.claimsService.updateClaims(this.claims);
    this.router.navigate(["profilemenu"]);
  }

    openEssPackPanel() {
      this.isDisplayEssDetail = true;
    }

    dismissEssPack() {
      this.isDisplayEssDetail = false;
    }
  closeVideo() {
    var iframe = document.querySelector('#exampleModal iframe') as HTMLIFrameElement;

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }

  }

  fnRedirectToEssPack() {
    this.isDisplayEssDetail = false;
    localStorage.setItem("isEssentialPackSubscribeDisplay", "1");
    this.router.navigate(["/essential-pack"]);
  }

   fnGoToSelfSetup(){
    this.router.navigate(["/self-setup"]);
  }

  fnGetOrgSelfSetupDetail() {
     this.selfSetupService.GetOrgSelfSetupDetail(this.claims.OrgId)
    .subscribe((response: IApiresponse<any>) => { });
    }

  fnShowBookDemoPanel() {
      if(!this.claims.isBasicFunctionPurchased) {
        this.isDisplayEssDetail = false;
        this.showBookDemoPanel = true;
      }
  }

  fnCloseBookDemoPanel() { 
    this.showBookDemoPanel = false;  
  }
  
}
